/*  eslint-disable */

import React, { useEffect, useMemo, useRef } from 'react';
import { useInfiniteQuery, useQuery } from 'react-query';
import { debounce, Grid } from '@material-ui/core';
import { IFilterOptions } from 'interfaces/SelectOptions';
import { useDispatchFilter, useSelectFilter } from 'hooks/planning/useFilter';
import { getCluster } from 'services/cluster';
import { postInspectionExecutorFilter } from 'services/inspection-checklist';
import { IInspectionExecutorFilterData } from 'interfaces/Grid';
import qs from 'qs';
import { IEquipmentFilterTree } from 'interfaces/Equipment';
import { postEquipmentTree } from 'services/equipment';
import AutocompleteMultipleCheckboxTree from 'components/atoms/AutocompleteMultipleCheckboxTree';
import useStyles from './style';

const TAKE = 1000000;
interface ICheckTree {
  updatedAt: Date | null;
  checkboxTree(tag: number[]): number[];
  responseCheckTree: any;
  toggleState: string;
  valueInstalattion: { label: string; id: string | number }[];
  valueIdFornecedor: any;
}

const ChecklistEquipamentOnly = ({
  updatedAt,
  checkboxTree,
  valueIdFornecedor,
  valueInstalattion,
  toggleState,
}: ICheckTree) => {
  const classes = useStyles();
  const changeFilter = useDispatchFilter();
  const localValue = valueInstalattion.map(item => item.id);
  const [isLoading, setIsLoading] = React.useState(false);

  const [
    planFilterOptionsContext,
    weekFilterOptionsContext,
    selectedInitialDateOptionContext,
    selectedFinalDateOptionContext,
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    executorFilterOptionsContext,
    equipmentFilterOptionsContext,
  ] = [
    useSelectFilter('plan'),
    useSelectFilter('week'),
    useSelectFilter('initialDate'),
    useSelectFilter('finalDate'),
    useSelectFilter('cluster'),
    useSelectFilter('installation'),
    useSelectFilter('executor'),
    useSelectFilter('equipment'),
  ];

  const allFilterContexts = [
    weekFilterOptionsContext,
    clusterFilterOptionsContext,
    installationFilterOptionsContext,
    executorFilterOptionsContext,
    equipmentFilterOptionsContext,
    selectedInitialDateOptionContext,
    selectedFinalDateOptionContext,
    updatedAt,
  ];

  /** ESTADO DOS FILTROS */
  const [filterWeekOptions, setFilterWeekOptions] = React.useState<
    IFilterOptions[]
  >(weekFilterOptionsContext);
  const [filterClusterOptions, setFilterClusterOptions] = React.useState<
    IFilterOptions[]
  >([]);
  const [filterExecutorOptions, setFilterExecutorOptions] = React.useState<
    IFilterOptions[]
  >([]);

  const [filterEquipmentOptions, setFilterEquipmentOptions] = React.useState<
    IEquipmentFilterTree[]
  >([]);
  /** FIM ESTADO DOS FILTROS */

  /** ATIVADORES DOS FILTROS */
  const pauseFilterWeek = React.useMemo<boolean>(() => {
    return weekFilterOptionsContext.length > 1;
  }, [weekFilterOptionsContext]);

  const pauseFilterEquipment = useMemo<boolean>(() => {
    return equipmentFilterOptionsContext.length > 0;
  }, [equipmentFilterOptionsContext]);

  const pauseFilterExecutor = useMemo<boolean>(() => {
    return executorFilterOptionsContext.length > 0;
  }, [executorFilterOptionsContext]);
  /** FIM ATIVADORES DOS FILTROS */

  /** IDS dos filtros selecionados */
  const clusterIds = React.useMemo(
    () => clusterFilterOptionsContext.map(item => Number(item?.value)),
    [clusterFilterOptionsContext],
  );
  const installationIds = React.useMemo(
    () => installationFilterOptionsContext.map(item => Number(item?.value)),
    [installationFilterOptionsContext],
  );

  const equipmentIds = equipmentFilterOptionsContext.map(item =>
    String(item?.value),
  );

  const plans = React.useMemo(
    () => planFilterOptionsContext.map(item => String(item?.value)),
    [planFilterOptionsContext],
  );

  const weeks = React.useMemo(
    () => weekFilterOptionsContext.map(item => String(item?.value)),
    [weekFilterOptionsContext],
  );
  const minDate = React.useMemo(
    () => selectedInitialDateOptionContext[0]?.value,
    [selectedInitialDateOptionContext],
  );

  const initialDateMemo = React.useMemo(
    () => selectedInitialDateOptionContext[0]?.value,
    [selectedInitialDateOptionContext],
  );

  const finalDateMemo = React.useMemo(
    () => selectedFinalDateOptionContext[0]?.value,
    [selectedFinalDateOptionContext],
  );
  const startDateMap = selectedInitialDateOptionContext.map(item =>
    String(item.value),
  );

  const start = React.useMemo(() => startDateMap[0], [startDateMap]);

  const endDateMap = selectedFinalDateOptionContext.map(item =>
    String(item.value),
  );

  const end = React.useMemo(() => endDateMap[0], [endDateMap]);
  const executors = React.useMemo(
    () => executorFilterOptionsContext.map(item => String(item?.value)),
    [executorFilterOptionsContext],
  );
  /** FIM IDS dos filtros selecionados */

  const [inputFieldValues, setInputFieldValues] = React.useState<{
    [key: string]: string;
  }>({});

  const handleChange = ({ name, value }: { name: string; value: any }) => {
    checkboxTree(value);
    changeFilter(name, value);
  };

  const getNextPageParam = React.useCallback(
    (
      lastPage: IInspectionExecutorFilterData,
      allPages: IInspectionExecutorFilterData[],
    ) => {
      const allResults = allPages.map(page => page.result).flat().length;
      if (allResults === 0) return 1;

      const hasNextPage = allResults < lastPage.count;
      if (hasNextPage) return allResults / TAKE + 1;

      return undefined;
    },
    [],
  );

  const executor = React.useMemo(() => {
    if (inputFieldValues?.executor && inputFieldValues?.executor.length >= 1) {
      return inputFieldValues?.executor;
    }
    return executorFilterOptionsContext.map(item => String(item?.value));
  }, [inputFieldValues?.executor, executorFilterOptionsContext]);

  /** QUERY DOS FILTROS */

  React.useEffect(() => {
    setIsLoading(false);

    const fetchFilterEquip = async () => {
      const params = {
        installationIds: localValue,
        type: 'BOP',
        areaType: valueIdFornecedor,
      };
      if (valueIdFornecedor.length > 0) {
        setIsLoading(true);
        const data = await postEquipmentTree(params);
        const returnData = data.data.result;
        setFilterEquipmentOptions(returnData);
        setIsLoading(false);
        return returnData;
      }
    };

    fetchFilterEquip();
  }, [valueIdFornecedor]);

  /** FIM QUERY DOS FILTROS */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterEquipamentosRef: any = useRef(null);
  const computedWeekOptions = React.useMemo<IFilterOptions[]>(() => {
    const combinedArray = [...filterWeekOptions, ...weekFilterOptionsContext];

    const filterObjs: { [key: string]: IFilterOptions } = combinedArray.reduce(
      (accumulator, currentValue) => {
        if (!accumulator[currentValue.value]) {
          return {
            ...accumulator,
            [currentValue.value]: currentValue,
          };
        }

        return accumulator;
      },
      {},
    );

    return Object.values(filterObjs);
  }, [filterWeekOptions, weekFilterOptionsContext]);

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <AutocompleteMultipleCheckboxTree
            id="equipment-filter"
            items={filterEquipmentOptions}
            onFilterChange={handleChange}
            name="equipment"
            label="Equip."
            placeholder=""
            disableClearable
            selectAllLabel="Selecionar Todos"
            ref={filterEquipamentosRef}
            loading={isLoading}
            toggleState={toggleState}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default ChecklistEquipamentOnly;
